import { createAction } from '@reduxjs/toolkit';

/**
 * Global action to reset all Redux state
 * All slices should listen to this action via extraReducers
 * and reset to their initialState when this action is dispatched
 */
export const resetReduxState = createAction('RESET_REDUX_STATE');

